import { inheritsLoose as _inheritsLoose } from '../_virtual/_rollupPluginBabelHelpers.js';
import { assert } from './assert.esm.js';
import { BaseError } from './error.esm.js';

var NFTURIParsingError = /*#__PURE__*/function (_BaseError) {
  _inheritsLoose(NFTURIParsingError, _BaseError);

  function NFTURIParsingError() {
    return _BaseError.apply(this, arguments) || this;
  }

  return NFTURIParsingError;
}(BaseError);
function parseNFT(uri, seperator) {
  if (seperator === void 0) {
    seperator = '/';
  }

  // parse valid nft spec (CAIP-22/CAIP-29)
  // @see: https://github.com/ChainAgnostic/CAIPs/tree/master/CAIPs
  try {
    assert(uri, 'parameter URI cannot be empty');

    if (uri.startsWith('did:nft:')) {
      // convert DID to CAIP
      uri = uri.replace('did:nft:', '').replace(/_/g, '/');
    }

    var _uri$split = uri.split(seperator),
        reference = _uri$split[0],
        asset_namespace = _uri$split[1],
        tokenID = _uri$split[2];

    var _reference$split = reference.split(':'),
        eip_namespace = _reference$split[0],
        chainID = _reference$split[1];

    var _asset_namespace$spli = asset_namespace.split(':'),
        erc_namespace = _asset_namespace$spli[0],
        contractAddress = _asset_namespace$spli[1];

    assert(eip_namespace && eip_namespace.toLowerCase() === 'eip155', 'Only EIP-155 is supported');
    assert(chainID, 'chainID not found');
    assert(contractAddress, 'contractAddress not found');
    assert(erc_namespace, 'erc namespace not found');
    assert(tokenID, 'tokenID not found');
    return {
      chainID: Number(chainID),
      namespace: erc_namespace.toLowerCase(),
      contractAddress: contractAddress,
      tokenID: tokenID
    };
  } catch (error) {
    throw new NFTURIParsingError(error + " - " + uri);
  }
}

export { NFTURIParsingError, parseNFT };
//# sourceMappingURL=parseNFT.esm.js.map
